import React from 'react'

export type Props = {}

export const License: React.VFC<Props> = () => {
  return (
    <div className="policy">
      <section className="policy__heading">
        <h2 className="title">AKIVERSE ART LICENSE</h2>
        <p className="text">Established: December 7, 2023</p>
      </section>
      <section className="policy__list">
        <h2>Purpose of Art License</h2>
        <p>
          The AKIVERSE team aims to make AKIVERSE design assets available for use by a wide range of creators
          in creative activities related to AKIVERSE, regardless of whether they are individuals or legal
          entities, for-profit or non-profit organizations. To achieve this goal, we have established an art
          license that allows creators to use AKIVERSE design assets.
          <br />
          <br />
          The fundamental principle of this art license is to promote an environment where creators can freely
          express themselves through AKIVERSE.
        </p>
      </section>
      <section className="policy__list">
        <h2>Basic Principles</h2>
        <ul className="list-indent">
          <li>
            <span>1</span>. We welcome derivative works.
          </li>
          <li>
            <span>2</span>. Use is allowed for both personal and commercial purposes.
          </li>
          <li>
            <span>3</span>. For-profit entities engaging in derivative works or fan activities should contact
            us individually.
          </li>
          <li>
            <span>4</span>. Hate speech, illegal activities, content contrary to public order and morality,
            harassment, defamation, violent expressions, etc., are prohibited.
          </li>
        </ul>
        <p>Based on the above basic principles, we define the art license for AKIVERSE assets as follows.</p>
      </section>
      <section className="policy__list">
        <h2>Usage</h2>
        <h3>Available Materials</h3>
        <ul className="list-indent">
          <li>
            - AKIVERSE assets provided through the official website, social media, and community channels.
          </li>
          <li>
            - These assets can be used freely, whether for personal or commercial purposes. Usage includes but
            is not limited to:
            <ul>
              <li>
                -- Creation, exhibition, distribution, streaming, and sale of content such as illustrations,
                manga, novels, videos, doujinshi, etc.
              </li>
              <li>
                -- Creation, distribution, and sale of applications, games, music, audio works, 2D/3D models,
                etc.
              </li>
              <li>
                -- Creation, exhibition, distribution, and sale of figures, dolls, cosplay, and other
                three-dimensional artworks, costumes, etc.
              </li>
              <li>-- Creation and sale of NFTs.</li>
            </ul>
          </li>
        </ul>
      </section>
      <section className="policy__list">
        <h2>Prohibitions</h2>
        <h3>Actions that Degrade the Image of AKIVERSE</h3>
        <ul className="list-indent">
          <li>
            - Usage methods that may be mistaken for official works or official content, such as titles of
            derivative works that are mistaken as official, acts of directly tracing assets, and claims of
            unofficial content as official.
          </li>
          <li>
            - Usage methods that infringe upon the rights of others, hate speech, harassment, defamatory
            actions, or actions contrary to public order and morality.
          </li>
          <li>- Use and public disclosure of game materials other than screenshots and gameplay videos.</li>
          <li>- Using original content or derivative works to express personal ideologies.</li>
          <li>- Using derivative works without the creator&apos;s permission.</li>
        </ul>
        <p>
          To maintain the world of AKIVERSE, we kindly request that content usage adheres to public order and
          morality.
        </p>
      </section>
      <section className="policy__list">
        <h2>Disclaimer</h2>
        <ul className="list-indent">
          <li>
            - AKIVERSE holds the copyright to original art related to AKIVERSE and the right to freely use it.
          </li>
          <li>
            - AKIVERSE may showcase and use derivative works related to AKIVERSE on social media and related
            services.
          </li>
          <li>- AKIVERSE reserves the right to freely change this art license without prior notice.</li>
          <li>- AKIVERSE is not responsible for troubles caused by derivative works.</li>
          <li>
            - This license has been created with reference to the following materials, and we express our
            gratitude for their contribution to understanding and creating advanced art licenses.
            <ul>
              <li>
                --
                <a href="https://touhou-project.news/guideline/">
                  Touhou Project Derivative Works Guidelines
                </a>
              </li>
              <li>
                --
                <a href="https://a16zcrypto.com/introducing-nft-licenses/">
                  a16z: The Can&apos;t Be Evil NFT Licenses
                </a>
              </li>
              <li>
                --
                <a href="https://www.notion.so/Ailis-Art-License-061c018f211b40d59874d2cf30234218?pvs=21">
                  Ailis Art License
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </section>
    </div>
  )
}
